export default "__VITE_ASSET__a732b04e__"